import { Directive, inject, input, TemplateRef } from "@angular/core";

/**
 * Marks an <ng-template> as one tab of an <app-cerrix-tabs>. The container reads the
 * label for the tab strip and renders the template of the active tab in its body.
 */
@Directive({
    selector: "ng-template[appCerrixTab]",
})
export class CerrixTabDirective {
    readonly label = input.required<string>();

    readonly template = inject(TemplateRef);
}
